const getHourMinString = (hour) => {
    if (hour)
        return Number(hour.toFixed(2)).toLocaleString("en", { useGrouping: false, minimumFractionDigits: 2 }).replace(".", ":");
    else
        return 0;
};

export {
    getHourMinString
};